import { datadogRum } from '@datadog/browser-rum';
import { SplitFactory } from '@splitsoftware/splitio';
import { env } from 'config/env';
import { SPLITIO_API_KEY } from 'config';
import { importLocalSplits } from 'config/importLocalSplits';
import { IBrowserSettings, IBrowserSDK } from '@splitsoftware/splitio/types/splitio';

// See local.split.yaml to change feature flags locally
// or run `yarn run -T cp-local-feature-flags if you haven't set this up yet
const features: IBrowserSettings['features'] | undefined =
  env.LOCAL_SPLITS === 'true' ? importLocalSplits() : undefined;

export class SplitIOManager {
  static createSplitFactory: (email: string) => IBrowserSDK = (email) => {
    const factory = SplitFactory({
      core: {
        authorizationKey: SPLITIO_API_KEY,
        key: email,
        trafficType: 'user',
      },
      features,
      startup: {
        readyTimeout: 5, // 5 sec (value recommended by Split.io support)
      },

      impressionListener: {
        logImpression: (impressionData) => {
          datadogRum.addFeatureFlagEvaluation(
            impressionData.impression.feature,
            impressionData.impression.treatment
          );
        },
      },
    });

    factory.Logger.enable();

    factory.Logger.setLogLevel('WARN');

    return factory;
  };
}

export const getFactory = (email: string): IBrowserSDK => {
  return SplitIOManager.createSplitFactory(email);
};
